import { useState, useEffect } from 'react';
import { getTimeSlot } from '@/lib/fmUtils';

/**
 * Hook that returns the current IST time slot, updating every 60 seconds.
 * Returns: 'morning_peak' | 'off_peak' | 'evening_peak' | 'closed'
 */
export function useTimeAdaptive() {
  const [timeSlot, setTimeSlot] = useState(getTimeSlot());

  useEffect(() => {
    const interval = setInterval(() => setTimeSlot(getTimeSlot()), 60000);
    return () => clearInterval(interval);
  }, []);

  return timeSlot;
}
